import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  transition: all 300ms ease-out;
`;

export const ToggleWrapper = styled.div<{ isAnotherInCallCard?: boolean }>`
  position: absolute;
  top: ${(props) => (props.isAnotherInCallCard ? '-35px' : '10px')};
  left: ${(props) => (props.isAnotherInCallCard ? '115px' : '-35px')};
`;

export const LoaderWrapper = styled.div`
  padding: 10px;
`;
